import React, { useEffect } from 'react';
import { validateTransferToken } from './authFunctions';
import { Progress } from '@awesomecomponents/mux';
import * as HttpStatus from 'http-status-codes';
import ERROR_CODES from './ErrorCodes';
import { useContext } from 'react';
import LoggerContext from './logger/LoggerContext';

import packageJson from '../../package.json';
const basePath = packageJson.homepage;

const Authenticator = ({
  transfer_token,
  history,
  business_unit,
  language,
  form_name,
  setLang,
  setIsAuthenticated,
  oidc,
}) => {
  const lang = language === 'fr' ? 'fr-CA' : 'en-CA';
  const logger = useContext(LoggerContext);
  useEffect(() => {
    const handleAuth = async () => {
      try {
        logger.info(`Authenticator: Validating transfer token`);
        const response = await validateTransferToken(transfer_token, business_unit, form_name).catch(() => {
          throw new Error(ERROR_CODES.VALIDATE_TRANSFER_TOKEN_FAILED);
        });

        const { transferInResponse } = response;

        const isCiamSession = transferInResponse?.hasOwnProperty('CIAM');

        const clientNumber = transferInResponse?.Identity?.clientNumber;
        const certificate = transferInResponse?.Identity?.certificate;

        logger.setContext({ customer: { group: clientNumber, cert: certificate } });

        logger.info(`Authenticator: Token validation successful`);

        if (!clientNumber) {
          logger.warn(`Authenticator: Client number not found in response.`);
        }

        if (!certificate) {
          logger.warn(`Authenticator: Certificate not found in response.`);
        }

        if (isCiamSession && transferInResponse.CIAM.amr === undefined) {
          logger.info(
            `Authenticator: AMR undefined for CIAM session for clientNumber: ${clientNumber} and cert: ${certificate}.`,
          );
        }

        // Conditions that will determine if step up is not needed
        // 1. ENABLE_STEP_UP is false
        // 2. Form is not e-bene-2
        // 3. Response.transferInResponse has no CIAM property indicating that on CIAM session exist
        // 4. CIAM.arm has 'otp' element indicating that step up has been done

        // HOTFIX: Skip all step up
        const isSteppedUp =
          !(window.__ENV__.ENABLE_STEP_UP === 'true') ||
          form_name !== 'e-bene-2' ||
          !isCiamSession ||
          transferInResponse?.CIAM.amr.includes('otp');

        if (isCiamSession) {
          sessionStorage.setItem('maxSessionExpirationTime', transferInResponse.CIAM.maxSessionExpirationTime);
        }

        if (!isSteppedUp) {
          await oidc.performStepUpAuthentication(lang, form_name, clientNumber, certificate, logger);

          // Return function to avoid displaying 401 error page when stepping up
          return;
        }

        if (response.status === HttpStatus.OK && isSteppedUp) {
          sessionStorage.setItem('isAuthenticated', true);
          setLang(lang);
          setIsAuthenticated(true);
          history.push(`${basePath}/${business_unit}/${form_name}`);
        } else {
          setLang(lang);
          setIsAuthenticated(false);
          history.push(`${basePath}/error`);
        }
      } catch (err) {
        setLang(lang);
        setIsAuthenticated(false);
        logger.error(`Authenticator: ERROR: ${err.message}`);
        history.push({ pathname: `${basePath}/error`, state: { error: err.message } });
      }
    };

    handleAuth();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <Progress />
    </div>
  );
};

export default Authenticator;
